import React, { useState } from 'react';
import { Eye } from 'lucide-react';
import { Button } from '../../ui/Button';
import { PropertyPreviewModal } from './PropertyPreviewModal';
import { Property } from '../../../types/property';

interface PropertyPreviewButtonProps {
  property: Property;
}

export const PropertyPreviewButton: React.FC<PropertyPreviewButtonProps> = ({ property }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handlePreviewClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Empêcher la propagation vers la carte
    e.preventDefault(); // Empêcher le comportement par défaut
    setIsPreviewOpen(true);
  };

  return (
    <>
      <Button
        variant="secondary"
        size="icon"
        onClick={handlePreviewClick}
        className="!p-2"
        title="Aperçu détaillé du bien"
      >
        <Eye className="h-4 w-4" />
      </Button>

      <PropertyPreviewModal
        property={property}
        isOpen={isPreviewOpen}
        onClose={() => setIsPreviewOpen(false)}
      />
    </>
  );
};